module.exports = __webpack_public_path__ + "images/img-1FzWU_A.jpg";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/dashboard/year-results/en/managers/81.jpg
// module id = 2016
// module chunks = 0